import { ContentMedia } from "./ContentMedia";

export { ContentMedia };
